/**
 * MainLayout.jsx
 *
 * Wraps all public + protected pages with:
 *   • AnnouncementBar (fixed top, above navbar)
 *   • Navbar
 *   • BottomNav (mobile only)
 *
 * Admin pages and auth pages render their own layouts and do NOT
 * use this wrapper.
 */

import { Outlet } from 'react-router-dom';
import AnnouncementBar from './AnnouncementBar';
import Navbar from './Navbar';
import BottomNav from './BottomNav';

const ANNOUNCEMENT_MESSAGES = [
  '✨ Free shipping on orders above ₹999 — Pan India delivery',
  '💎 Handcrafted imitation jewellery with tarnish-resistant finish',
  '🎁 Use code WELCOME10 for 10% off your first order',
];

export default function MainLayout() {
  return (
    <>
      <AnnouncementBar
        messages={ANNOUNCEMENT_MESSAGES}
        bgColor="#1A1A1A"
        textColor="#FFFFFF"
      />
      <Navbar />
      <Outlet />
      <BottomNav />
    </>
  );
}